import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class AnimationIteration extends BaseOption {
  static userInterfaceComponent = {
    label: "Iteration",
    component: inspectorTools.AUTOCOMPLETE,
    canSetOtherStates: [],
    props: {
      showAllResultsOnClick: true,
      allowCustomValue: true,
      items: [
        { value: "infinite", label: "Infinite" },
      ],
    },
  };

  static defaultValue = 1;
}
